import { injectReducer } from 'store/reducers.js'
import { authRoute } from 'helpers/routes'
import { injectExternalList } from 'helpers/actions'

export const TypesRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'types',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/TypesContainer').default

      const actions = require('./modules/types').actions
      const reducer = require('./modules/types').default

      injectReducer(store, { key: 'types', reducer })
      injectExternalList(store, 'options')
      injectExternalList(store, 'uoms')

      store.dispatch(actions.get())

      cb(null, Container)
    }, 'types')
  }
})

export const NewTypeRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'types/new',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/NewTypeContainer').default

      const reducer = require('./modules/type').default

      injectReducer(store, { key: 'type', reducer })
      injectExternalList(store, 'options')
      injectExternalList(store, 'uoms')

      cb(null, Container)
    }, 'types')
  }
})

export const EditTypeRoute = (store) => Object.assign({}, authRoute(store), {
  path: 'types/:id/edit',
  authentication: 'admin',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const Container = require('./containers/EditTypeContainer').default

      const actions = require('./modules/type').actions
      const reducer = require('./modules/type').default

      injectReducer(store, { key: 'type', reducer })
      injectExternalList(store, 'options')
      injectExternalList(store, 'uoms')

      store.dispatch(actions.get(nextState.params.id))

      cb(null, Container)
    }, 'types')
  }
})

export default function (store) {
  return [
    NewTypeRoute(store),
    EditTypeRoute(store),
    TypesRoute(store)
  ]
}



// WEBPACK FOOTER //
// ./src/routes/Types/index.js